import _find from 'lodash.find'
import _map from 'lodash.map'
import _uniq from 'lodash.uniq'

// Proper diatonic chord progressions with weighted scoring
const songKeys = [
  // Major keys - I, ii, iii, IV, V, vi, vii°
  { key: 'C', chords: { C: 2.0, Dm: 1.0, Em: 0.8, F: 1.5, G: 1.8, Am: 1.2, Bdim: 0.6 } },
  { key: 'G', chords: { G: 2.0, Am: 1.0, Bm: 0.8, C: 1.5, D: 1.8, Em: 1.2, 'F#dim': 0.6 } },
  { key: 'D', chords: { D: 2.0, Em: 1.0, 'F#m': 0.8, G: 1.5, A: 1.8, Bm: 1.2, 'C#dim': 0.6 } },
  { key: 'A', chords: { A: 2.0, Bm: 1.0, 'C#m': 0.8, D: 1.5, E: 1.8, 'F#m': 1.2, 'G#dim': 0.6 } },
  { key: 'E', chords: { E: 2.0, 'F#m': 1.0, 'G#m': 0.8, A: 1.5, B: 1.8, 'C#m': 1.2, 'D#dim': 0.6 } },
  { key: 'B', chords: { B: 2.0, 'C#m': 1.0, 'D#m': 0.8, E: 1.5, 'F#': 1.8, 'G#m': 1.2, 'A#dim': 0.6 } },
  { key: 'F#', chords: { 'F#': 2.0, 'G#m': 1.0, 'A#m': 0.8, B: 1.5, 'C#': 1.8, 'D#m': 1.2, 'E#dim': 0.6 } },
  { key: 'F', chords: { F: 2.0, Gm: 1.0, Am: 0.8, Bb: 1.5, C: 1.8, Dm: 1.2, Edim: 0.6 } },
  { key: 'Bb', chords: { Bb: 2.0, Cm: 1.0, Dm: 0.8, Eb: 1.5, F: 1.8, Gm: 1.2, Adim: 0.6 } },
  { key: 'Eb', chords: { Eb: 2.0, Fm: 1.0, Gm: 0.8, Ab: 1.5, Bb: 1.8, Cm: 1.2, Ddim: 0.6 } },
  { key: 'Ab', chords: { Ab: 2.0, Bbm: 1.0, Cm: 0.8, Db: 1.5, Eb: 1.8, Fm: 1.2, Gdim: 0.6 } },
  { key: 'Db', chords: { Db: 2.0, Ebm: 1.0, Fm: 0.8, Gb: 1.5, Ab: 1.8, Bbm: 1.2, Cdim: 0.6 } },

  // Minor keys - i, ii°, III, iv, v, VI, VII
  { key: 'Am', chords: { Am: 2.0, Bdim: 0.6, C: 1.5, Dm: 1.2, Em: 1.0, F: 1.3, G: 1.8 } },
  { key: 'Em', chords: { Em: 2.0, 'F#dim': 0.6, G: 1.5, Am: 1.2, Bm: 1.0, C: 1.3, D: 1.8 } },
  { key: 'Bm', chords: { Bm: 2.0, 'C#dim': 0.6, D: 1.5, Em: 1.2, 'F#m': 1.0, G: 1.3, A: 1.8 } },
  { key: 'F#m', chords: { 'F#m': 2.0, 'G#dim': 0.6, A: 1.5, Bm: 1.2, 'C#m': 1.0, D: 1.3, E: 1.8 } },
  { key: 'C#m', chords: { 'C#m': 2.0, 'D#dim': 0.6, E: 1.5, 'F#m': 1.2, 'G#m': 1.0, A: 1.3, B: 1.8 } },
  { key: 'G#m', chords: { 'G#m': 2.0, 'A#dim': 0.6, B: 1.5, 'C#m': 1.2, 'D#m': 1.0, E: 1.3, 'F#': 1.8 } },
  { key: 'D#m', chords: { 'D#m': 2.0, 'E#dim': 0.6, 'F#': 1.5, 'G#m': 1.2, 'A#m': 1.0, B: 1.3, 'C#': 1.8 } },
  { key: 'Dm', chords: { Dm: 2.0, Edim: 0.6, F: 1.5, Gm: 1.2, Am: 1.0, Bb: 1.3, C: 1.8 } },
  { key: 'Gm', chords: { Gm: 2.0, Adim: 0.6, Bb: 1.5, Cm: 1.2, Dm: 1.0, Eb: 1.3, F: 1.8 } },
  { key: 'Cm', chords: { Cm: 2.0, Ddim: 0.6, Eb: 1.5, Fm: 1.2, Gm: 1.0, Ab: 1.3, Bb: 1.8 } },
  { key: 'Fm', chords: { Fm: 2.0, Gdim: 0.6, Ab: 1.5, Bbm: 1.2, Cm: 1.0, Db: 1.3, Eb: 1.8 } },
  { key: 'Bbm', chords: { Bbm: 2.0, Cdim: 0.6, Db: 1.5, Ebm: 1.2, Fm: 1.0, Gb: 1.3, Ab: 1.8 } }
]

// Enharmonic equivalents for chord normalization
const enharmonicMap = {
  'A#': 'Bb',
  Bb: 'Bb',
  'C#': 'Db',
  Db: 'Db',
  'D#': 'Eb',
  Eb: 'Eb',
  'F#': 'Gb',
  Gb: 'Gb',
  'G#': 'Ab',
  Ab: 'Ab'
}

const chordRegex = /\{\S+?\}/gi

export const getSongChords = (songContent) => {
  const matches = songContent.match(chordRegex)
  if (!matches) return []
  const uniqueChords = _uniq(matches)
  return _map(uniqueChords, uc => uc.replace(/\{|\}/g, ''))
}

export const getKeyChords = (inKey) => {
  const match = _find(songKeys, songKey => songKey.key === inKey)
  if (!match) {
    return []
  }

  return Object.keys(match.chords)
}
const normalizeChord = (chordStr) => {
  const cleaned = chordStr.replace(/\{|\}/g, '')

  // Extract root note (1 or 2 characters)
  let root = cleaned.substring(0, 1)
  if (cleaned.length > 1 && (cleaned[1] === '#' || cleaned[1] === 'b')) {
    root = cleaned.substring(0, 2)
  }

  // Normalize enharmonics
  if (enharmonicMap[root]) {
    root = enharmonicMap[root]
  }

  // Extract quality (everything after root)
  const quality = cleaned.substring(root.length)

  // Determine chord type
  let chordType = 'major' // default
  if (quality.includes('dim') || quality.includes('°')) {
    chordType = 'dim'
  } else if (quality.includes('m') && !quality.includes('maj')) {
    chordType = 'minor'
  }

  // Build normalized chord name
  let normalizedChord = root
  if (chordType === 'minor') normalizedChord += 'm'
  if (chordType === 'dim') normalizedChord += 'dim'

  return normalizedChord
}

export default (songContent) => {
  const uniqueChords = getSongChords(songContent)
  const keyScores = songKeys.map(key => ({ ...key, score: 0, hits: [] }))

  uniqueChords.forEach(chord => {
    const normalizedChord = normalizeChord(chord)

    keyScores.forEach(key => {
      if (key.chords[normalizedChord]) {
        if (!key.hits.includes(normalizedChord)) {
          key.score += key.chords[normalizedChord]
          key.hits.push(normalizedChord)
        }
      }
    })
  })

  // Sort keys by score (highest first)
  keyScores.sort((a, b) => b.score - a.score)

  // Return top scoring keys (handle ties)
  const topScore = keyScores[0].score
  if (topScore === 0) return []

  return keyScores.filter(key => key.score === topScore)
}
